/*
 * @Author: Teemo Ding
 * @Date: 2022-05-10 09:10:55
 * @LastEditTime: 2022-05-11 08:33:42
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/ReportingDashboard/Components/BarChartItem/index.tsx
 */
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import Link from '@/src/components/Link/Link';
import { QuestionCircleFilled } from '@ant-design/icons';
import { get } from 'lodash';
import React, { ReactNode } from 'react';
import WhiteBackgroundTooltip, {
  TooltipContainer,
  TooltipContent,
  TooltipTitle,
} from 'src/components/GlobalTooltip/WhiteBackgroundTooltip';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

interface IProps {
  title: string | ReactNode;
  barTitle: string;
  data: any;
  viewReportUrl?: string;
  overlayTitle: string;
  overlayDescription: string;
  formatAmount?: (value: string | number) => string;
}

const BarChartItem = (props: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    title,
    barTitle,
    viewReportUrl,
    overlayTitle,
    overlayDescription,
    formatAmount,
    data: { lines = [], total = '' },
  } = props;
  const l = lines.map((i) => {
    const v = get(i, 'value').replaceAll(',', '');
    return { ...i, value: v };
  });
  const getNumber = (v) => Number(String(v).replace(/,/g, ''));
  const max = getNumber(get(lines, ['0', 'value']));
  const length = (value) => Number((Number(value) / max) * 100).toFixed(2);
  return (
    <div className={css.contain}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={css.containerClassName}
        {...(viewReportUrl && {
          rightPart: (
            <Link className={css.viewReport} to={viewReportUrl}>
              {getI18n('dashboard.innercomponents.lineChartItem.viewreports')}
            </Link>
          ),
        })}
        title={
          <div>
            {title}
            <WhiteBackgroundTooltip
              overlayClassName={css.overlayClassName}
              title={
                <TooltipContainer>
                  <TooltipTitle>{overlayTitle}</TooltipTitle>
                  <TooltipContent>{overlayDescription}</TooltipContent>
                </TooltipContainer>
              }
              placement='rightTop' //overlayClassName
            >
              <QuestionCircleFilled className={css.icon} />
            </WhiteBackgroundTooltip>
          </div>
        }>
        {!!(lines || []).length && (
          <div className={css.barTitle}>{barTitle}</div>
        )}
        {l.map((item, index) => (
          <div key={index} className={css.barContain}>
            <div className={css.productName}>{item.label}</div>
            <div className={css.productValue}>
              <div className={css.value}>
                {formatAmount ? formatAmount(item.value) : item.value}
              </div>
              <div className={css.progress}>
                <div
                  className={css.progressBar}
                  style={{
                    width: length(getNumber(item.value)) + '%',
                  }}></div>
              </div>
            </div>
          </div>
        ))}
        {!!(lines || []).length && (
          <div className={`${css.barContain} ${css.total}`}>
            <div className={css.productName}>
              {getI18n('dashboard.reportingDashboardcommon.total')}
            </div>
            <div className={css.productValue}>
              <div className={css.value}>{total}</div>
            </div>
          </div>
        )}
        {!(lines || []).length && (
          <div className={css.noData}>
            {getI18n('dashboard.innercomponents.barChartItem')}
          </div>
        )}
      </SectionWrapper>
    </div>
  );
};

export default BarChartItem;
